/* eslint-disable key-spacing */
/* eslint-disable no-multi-spaces */
import { parseNumber } from '@utils/numberConversions'
import { INTEREST_RATE_CONTROL } from '../Views/Form/AssetFields'
import { annualIncreaseInMonthlyContributionFor } from '../Views/Form/annualIncrease'
import invert from 'lodash/invert'
import toLower from 'lodash/toLower'
import { R } from '@utils/currency'

export const updateAsset = async (state, newAsset) => {
  const updatedAsset = { ...state.asset, ...newAsset }

  await state.crudActions.update(updatedAsset)
}

export const createAsset = async (state, newAsset) => {
  const { crudActions } = state

  await crudActions.create(newAsset)
}

export const buildAsset = (asset, assetType, riskProfile, assumptions, isExistingAsset) => {
  const { inflation } = assumptions
  const date = new Date()

  const builtAsset = {
    asset_type: assetType,
    name: asset.name || 'No name',
    price_date: date,
    currency: asset.assetCurrency || 'zar',
    review_date: asset.reviewDate || null,
    gross_value: parseNumber(asset.gross) || 0,
    monthly_contribution: parseNumber(asset.monthlyContribution) || 0,
    employer_monthly_contribution: parseNumber(asset.employerMonthlyContribution) || 0,
    annual_increase_in_monthly_contribution: annualIncreaseInMonthlyContributionFor(asset),
    annual_increase_follows_plan_inflation: !!asset.usePlanInflation,
    monthly_income: getMonthlyIncomeForAssetByAssetType(asset, assetType),
    allow_automated_income_calculation: asset.allowAutomatedIncomeCalculation,
    term_of_debt: parseNumber(asset.termOfDebt) || 0,
    interest_rate: determineAssetInterestRate(asset, riskProfile, inflation),
    interest_rate_control: getInterestRateControl(asset),
    liability: parseNumber(asset.liability) || 0,
    asset_portfolio_id: asset.assetPortfolioId,
    service_provider_id: asset.serviceProviderId,
    contract_number: asset.contractNumber || null,
    base_cost: parseNumber(asset.baseCost) || 0,
    composition: asset.composition || 'standalone',

    domestic_equity: parseNumber(asset.domesticEquity) / 100 || null,
    domestic_property: parseNumber(asset.domesticProperty) / 100 || null,
    domestic_bonds: parseNumber(asset.domesticBonds) / 100 || null,
    domestic_cash: parseNumber(asset.domesticCash) / 100 || null,
    offshore_equity: parseNumber(asset.offshoreEquity) / 100 || null,
    offshore_property: parseNumber(asset.offshoreProperty) / 100 || null,
    offshore_bonds: parseNumber(asset.offshoreBonds) / 100 || null,
    offshore_cash: parseNumber(asset.offshoreCash) / 100 || null,

    new: !isExistingAsset,

    // Asset Events
    asset_events_attributes: [
      { ...asset.changeGrossIncomeEvent },
      { ...asset.changeMonthlyContributionEvent },
      { ...asset.matureRetirementAssetEvent }
    ],

    ...(asset.composition === 'two_pot' && {
      assets_attributes: [
        { ...asset.potBreakdown?.savingsPot },
        { ...asset.potBreakdown?.vestedPot },
        { ...asset.potBreakdown?.retirementPot },
      ]
    }),
  }

  return builtAsset
}

const getInterestRateControl = (asset) =>
  toLower(invert(INTEREST_RATE_CONTROL)[asset.interestRateControl]) || 1

const determineAssetInterestRate = (asset) => {
  if (asset.interestRate) {
    return parseNumber(asset.interestRate) / 100
  }
  return 0
}

const getMonthlyIncomeForAssetByAssetType = (asset, assetType) => {
  if (assetType === 'investment_property') {
    return parseNumber(asset.monthlyProfit) || 0
  } else if (assetType === 'savings_pot') {
    return (parseNumber(asset.monthlyIncome) || 0) / 12
  } else {
    return parseNumber(asset.monthlyIncome) || 0
  }
}
